/**
 * Helper function to sort numerically instead of alphabetically.
 * e.g. [1, 10, 5, 15] sorted alphabetically will return [1, 10, 15, 5] instead of
 * the desired [1, 5, 10, 15]
 */
export function compareNumbers(a: number, b: number): number {
  return a - b;
}
